import { DateTime } from 'luxon';
import {
  BenefitDTO,
  BenefitDTOBenefitEnum,
  CreditCardBenefitDetailsDTO,
  CreditCardBenefitDetailsDTOStatusEnum,
} from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class CreditCardBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailsCreditCard = activeBenefit.details as CreditCardBenefitDetailsDTO;

    const commonItemProps = {
      icon: getBenefitIcon(BenefitDTOBenefitEnum.CreditCard),
      titleKey: `benefit.${BenefitDTOBenefitEnum.CreditCard}.name`,
      picture: BENEFIT_PICTURES[BenefitDTOBenefitEnum.CreditCard],
    };

    if (detailsCreditCard.currentlyActivated === false) {
      return {
        ...commonItemProps,
        navigateTo: `/credit-card/balance`,
        descriptionKey: 'benefitModule:benefit.CREDIT_CARD.description',
        descriptionValues: { amount: detailsCreditCard.cardBalance },
        benefitProgress: 100,
      };
    }

    const isCreditCardActive =
      detailsCreditCard.status === CreditCardBenefitDetailsDTOStatusEnum.Active ||
      detailsCreditCard.status === CreditCardBenefitDetailsDTOStatusEnum.Expiring;

    return {
      ...commonItemProps,
      navigateTo: `/credit-card`,
      descriptionKey: `benefitModule:benefit.${BenefitDTOBenefitEnum.CreditCard}.headerStatus.${detailsCreditCard.status}`,
      descriptionValues: {
        startDate: new Date(detailsCreditCard.startDate),
        endDate: detailsCreditCard.endDate ? DateTime.fromISO(detailsCreditCard.endDate).plus({ months: 1 }).toJSDate() : undefined,
      },
      benefitProgress: isCreditCardActive ? 100 : 0,
    };
  }
}
